import $ from 'jquery';

$( document ).ready( () => {
  $( '.nav-handle' ).on( 'click', () => {
    $( '.nav' ).toggleClass( 'open' )
    $( 'body' ).toggleClass( 'no-scroll' );
  } )
  $( '.close-handle' ).on( 'click', () => {
    $( '.nav' ).toggleClass( 'open' )
    $( 'body' ).toggleClass( 'no-scroll' );
  } )

  if( $( '.page-header' ).length ) {
    var position = $( window ).scrollTop(); 
    var navHeight = $( '.nav' ).height();
    var headerHeight = $( '.page-header' ).height() + navHeight;
    // should start at 0

    $( window ).on( 'scroll', () => {
      var scroll = $( window ).scrollTop();
      //if the user scrolls past the navigation height, adds position fixed 
      // and translates the menu -100%;
      if ( scroll >= navHeight ) { 
        $( '.nav' ).addClass( 'nav-fix' );
      } else {
        $( '.nav' ).removeClass( 'nav-fix' );
      }
      // when the user scrolls page the hero, adds a nav-animate class so 
      // the fixed nav can now animate
      if( scroll > position || scroll <= navHeight) { 
        $( '.nav' ).removeClass( 'nav-animate' );
      } else {
        $( '.nav' ).addClass( 'nav-animate' );
      }
      position = scroll;
      // when the user makes an upwards scroll the nav translates to 0% 
      // if it has the nav-animate class also
      if ( scroll >= headerHeight ) {
        $( '.nav' ).addClass( 'nav-show' );
      } else {
        $( '.nav' ).removeClass( 'nav-show' );
      }
    });
  }
});
